const BASE_URL = 'files'

export default {
  GET_FILE: `/${BASE_URL}`,
  SEND_FILE: `/${BASE_URL}`,
}
